<template>
  <div class="oneui">
    <div></div>
    <div class="center-div" style="position: fixed; width: 100vw; height: var(--top-padding);">
      <div class="nameWrapper one">
        <span class="current">{{ $t('pages.settings.help')}}</span>
      </div>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <SettingButton  text="pages.support.navigation" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingButton from "../../components/SettingButton"
export default {
  name: "HelpSupport",
  components: { SettingButton },
}
</script>